var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarDeleteGray = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.875 4.42188H3.125",
  stroke: "rgba(0, 0, 0, 0.12)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.875 1.92188H13.125",
  stroke: "rgba(0, 0, 0, 0.12)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.625 4.42188V16.2969C15.625 16.4626 15.5592 16.6216 15.4419 16.7388C15.3247 16.856 15.1658 16.9219 15 16.9219H5C4.83424 16.9219 4.67527 16.856 4.55806 16.7388C4.44085 16.6216 4.375 16.4626 4.375 16.2969V4.42188",
  stroke: "rgba(0, 0, 0, 0.12)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarDeleteGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_delete_gray.1b9686a5b98de8fe3403ab14155caac6.svg";